// @ts-ignore

import React, { useContext } from "react";
import Form from "react-jsonschema-form";
import { State } from "../context/State";
import { Form as FormModel } from "../models/Form";
import { Layer } from "../App";
import MaterialJsonSchemaForm from "react-jsonschema-form-material-ui";

export interface DynamicFormProps {
  layer: Layer;
  form: FormModel;
  handleClose: Function;
  setContentKey: Function;
}

export const DynamicForm = (props: DynamicFormProps) => {
  const { layer, form, handleClose, setContentKey } = props;
  const { addLayer, layers, setLayers, setState, state } = useContext(State)!;

  const { fn, initial, schema } = form;

  const onSubmit = (value: any) => {
    fn({
      formData: value.formData,
      layer,
      addLayer,
      handleClose,
      layers,
      setContentKey,
      setLayers,
      setState,
      state
    });
  };

  return (
    <div style={{ fontSize: "1em" }}>
      <MaterialJsonSchemaForm
        schema={schema}
        // uiSchema={ui}
        formData={initial}
        // onCancel={this.onCancel}
        onSubmit={onSubmit}
        // onUpload={this.onUpload}
        // onChange={onFormChanged}
        submitOnEnter
        activityIndicatorEnabled
      />
    </div>
  );
};
